import { configureStore } from "@reduxjs/toolkit";
import donationReducer from "./dontaionSlice";

const store = configureStore({
  reducer: {
    donation: donationReducer,
  },
});

export default store;
